import { landingButtonGradient } from "./LandingUtils";

export const modernPlanStyles = {
    // Main container with gradient background
    container: {
        minHeight: '100vh',
        background : 'linear-gradient(135deg, rgb(232, 247, 237) 0%, rgba(255, 255, 255, 0.98) 50%, rgb(201 201 201) 100%)',
        // background: 'linear-gradient(135deg, rgba(82, 196, 26, 0.2) 0%, rgb(247, 250, 252) 50%, rgb(247, 250, 252) 100%)',
        //background: 'linear-gradient(135deg, rgb(232, 247, 237) 0%, rgb(255 255 255 / 98%) 50%, rgb(232, 247, 237) 100%)',
        padding: '2rem',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
       // color: '#000',
    },

    // Header section
    header: {
        textAlign: 'center',
        marginBottom: '2.5rem',
        //color: 'white',
    },

    backButton: {
        position: 'absolute',
        top: '2rem',
        left: '2rem',
        background: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        //color: 'white',
        borderRadius: '12px',
        padding: '0.5rem 1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontWeight: '500',
        transition: 'all 0.3s ease',
    },

    headerTitle: {
        fontSize: '2.5rem',
        fontWeight: '700',
        margin: '0 0 0.5rem 0',
       // background: 'linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%)',
        // WebkitBackgroundClip: 'text',
        // WebkitTextFillColor: 'transparent',
    },

    headerSubtitle: {
        fontSize: '1.1rem',
        opacity: 0.9,
        fontWeight: '400',
    },

    // Main content area
    contentContainer: {
        maxWidth: '1400px',
        margin: '0 auto',
    },

    // Left column - Plan card
    planCard: {
        background: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        padding: '2rem',
        marginBottom: '2rem',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.3s ease',
    },

    planHeader: {
        marginBottom: '2rem',
    },

    planBadge: {
        background: landingButtonGradient,
        color: 'white',
        padding: '0.25rem 0.75rem',
        borderRadius: '20px',
        fontSize: '0.8rem',
        fontWeight: '600',
        marginBottom: '1rem',
        display: 'inline-block',
    },

    planTitle: {
        fontSize: '2rem',
        fontWeight: '700',
        //color: 'white',
        margin: '0 0 0.5rem 0',
    },

    planSubtitle: {
        //color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '1rem',
        marginBottom: '1.5rem',
    },

    priceSection: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '2rem',
    },

    price: {
        fontSize: '3rem',
        fontWeight: '800',
        color: '#4ade80',
        margin: 0,
    },

    period: {
        fontSize: '1.5rem',
        // color: 'rgba(255, 255, 255, 0)',
        fontWeight: '500',
    },

    discountBadge: {
        background: 'linear-gradient(135deg, #f59e0b, #d97706)',
        color: 'white',
        padding: '0.25rem 0.75rem',
        borderRadius: '12px',
        fontSize: '0.8rem',
        fontWeight: '600',
        marginTop: '0.5rem',
        marginLeft: '0.5rem',
        display: 'inline-block',
    },

    // Features section
    featuresSection: {
        marginBottom: '2rem',
    },

    sectionTitle: {
        //color: 'white',
        fontSize: '1.2rem',
        fontWeight: '600',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },

    featuresGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1rem',
    },

    featureCard: {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '16px',
        // padding: '1.25rem',
        //color: 'white',
        transition: 'all 0.3s ease',
    },

    featureIcon: {
        fontSize: '1.5rem',
        marginBottom: '0.5rem',
        color: '#4ade80',
    },

    featureText: {
        fontSize: '0.95rem',
        fontWeight: '500',
        //color: 'white',
    },

    // Timeline section
    timelineCard: {
        background: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        padding: '2rem',
        marginBottom: '2rem',
    },

    timelineGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1.5rem',
    },

    timelineItem: {
        textAlign: 'center',
        padding: '1.5rem',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.15)',
    },

    timelineIcon: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        margin: '0 auto 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        color: 'white',
    },

    timelineTitle: {
        //color: 'white',
        fontSize: '1rem',
        fontWeight: '600',
        marginBottom: '0.5rem',
    },

    timelineDate: {
       // color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '0.9rem',
    },

    // Right column - Billing summary
    billingSummaryCard: {
        background: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        paddingBottom: '0',
        padding: '2rem',
        marginBottom: '2rem',
        position: 'sticky',
        top: '2rem',
    },

    summaryTitle: {
        //color: 'white',
        fontSize: '1.3rem',
        fontWeight: '600',
        marginBottom: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },

    summaryRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        // color: 'rgba(255, 255, 255, 0.9)',
        fontSize: '1rem',
    },

    summaryLabel: {
        fontWeight: '500',
    },

    summaryValue: {
        fontWeight: '600',
    },

    discountRow: {
         color: '#4ade80 !important',
    },

    totalSection: {
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        // padding: '1.5rem 0',
        marginTop: '1rem',
        marginBottom: '1.5rem',
    },

    totalLabel: {
        fontSize: '1.1rem',
        fontWeight: '600',
        //color: 'white',
    },

    totalAmount: {
        fontSize: '1.8rem',
        fontWeight: '800',
        color: '#4ade80',
    },

    securityAlert: {
        background: 'rgba(74, 222, 128, 0.15)',
        border: '1px solid rgba(74, 222, 128, 0.3)',
        borderRadius: '12px',
        padding: '1rem',
        // marginBottom: '1.5rem',
    },

    securityText: {
        //color: 'rgba(255, 255, 255, 0.9)',
        fontSize: '0.9rem',
    },

    // Next steps card
    stepsCard: {
        background: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '24px',
        padding: '2rem',
        marginTop: '2rem',
    },

    stepItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1.5rem',
        padding: '1rem',
        borderRadius: '12px',
        transition: 'all 0.3s ease',
    },

    stepNumber: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1rem',
        fontWeight: '600',
        //color: 'white',
        flexShrink: 0,
    },

    stepActive: {
        background: 'linear-gradient(135deg, #4ade80 0%, #22c55e 100%)',
    },

    stepCompleted: {
        background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
    },

    stepPending: {
        background: 'rgba(255, 255, 255, 0.2)',
    },

    stepContent: {
        flex: 1,
    },

    stepTitle: {
        //color: 'white',
        fontSize: '1rem',
        fontWeight: '600',
        marginBottom: '0.25rem',
    },

    stepDescription: {
        //color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '0.9rem',
    },

    // Action buttons
    actionButtons: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },

    proceedButton: {
        background: landingButtonGradient,
        border: 'none',
        borderRadius: '16px',
        padding: '1rem 2rem',
        fontSize: '1.1rem',
        fontWeight: '600',
        color: 'white',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        transition: 'all 0.3s ease',
        boxShadow: '0 10px 25px rgba(74, 222, 128, 0.3)',
    },

    backToPlansButton: {
        background: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '16px',
        padding: '0.8rem 2rem',
        fontSize: '1rem',
        fontWeight: '500',
        //color: 'white',
        height: 'auto',
        transition: 'all 0.3s ease',
    },

    // Info section at bottom
    infoSection: {
        marginTop: '3rem',
    },

    infoCard: {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '24px',
        padding: '2rem',
    },

    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '2rem',
    },

    infoItem: {
        textAlign: 'center',
    },

    infoItemTitle: {
        //color: 'white',
        fontSize: '1.1rem',
        fontWeight: '600',
        marginBottom: '0.5rem',
    },

    infoItemText: {
        //color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '0.95rem',
        lineHeight: '1.5',
    },

    // Animation variants for framer motion
    containerVariants: {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 0.6,
                staggerChildren: 0.1
            }
        }
    },

    cardVariants: {
        hidden: { 
            opacity: 0, 
            y: 30,
            scale: 0.95 
        },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    },

    floatingAnimation: {
        y: [0, -10, 0],
        transition: {
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
        }
    },
};
